export const BAR_FEATURES = [
  { key: 'poolTable', label: 'Pool Table', question: 'Does this bar have a pool table?' },
  { key: 'darts', label: 'Darts', question: 'Does this bar have darts?' },
  { key: 'cashOnly', label: 'Cash Only', question: 'Is this bar cash only?' },
  { key: 'jukebox', label: 'Jukebox', question: 'Does this bar have a jukebox?' },
  { key: 'outdoorSeating', label: 'Patio/Outdoor', question: 'Does this bar have outdoor seating?' },
  { key: 'liveMusic', label: 'Live Music', question: 'Does this bar have live music?' },
  { key: 'happyHour', label: 'Happy Hour', question: 'Does this bar have a happy hour?' },
  { key: 'touchTunes', label: 'TouchTunes', question: 'Does this bar have TouchTunes?' },
  { key: 'triviaNights', label: 'Trivia Nights', question: 'Does this bar have trivia nights?' },
  { key: 'euchre', label: 'Euchre', question: 'Does this bar have Euchre games?', metros: ['chicago', 'milwaukee'] },
  { key: 'oldStyleSign', label: 'Old Style Sign', question: 'Does this bar have an Old Style sign outside?', metros: ['chicago'] },
  { key: 'photoBooth', label: 'Photo Booth', question: 'Does this bar have a photo booth?' },
  { key: 'popcorn', label: 'Popcorn', question: 'Does this bar have free popcorn?' },
];

export const FEATURE_VOTE_THRESHOLD = 0.6;
export const FEATURE_MIN_VOTES = 10;

export function featureAppliesToMetro(feature, metroId) {
  if (!feature?.metros?.length) return true;
  return Boolean(metroId && feature.metros.includes(metroId));
}

export function getFeaturesForMetro(metroId) {
  return BAR_FEATURES.filter((feature) => featureAppliesToMetro(feature, metroId));
}
